export enum METHOD_API {
    GENERATE_INVOICE_LIST = 'td_oneaccess.api.sales.invoice.generate_invoice_list',
    PRINT_BULK_PICKING_LIST = 'td_oneaccess.api.print.online_sales_order.print_bulk_picking_list'
}

export const BASE_URL = process.env.REACT_APP_BASE_URL